module.exports = __webpack_public_path__ + "images/176_1024.jpg";